export const patientGenderOptions = [
  'male',
  'female',
  'unknown',
  'other',
] as const
